// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// var admin = require("firebase-admin");

// var serviceAccount = require("./cars-3ea0d-firebase-adminsdk-wabzn-7426e5b719.json");

// admin.initializeApp({
//   credential: admin.credential.cert(serviceAccount)
// });
// import { getAnalytics } from "firebase/analytics";
// import "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAkxH3jrWuSusqu-YEwp6CBWDE5VbHhUys",
  authDomain: "cars-3ea0d.firebaseapp.com",
  projectId: "cars-3ea0d",
  storageBucket: "cars-3ea0d.appspot.com",
  messagingSenderId: "237289722535",
  appId: "1:237289722535:web:d7836e6f924b6a6ef38182",
  measurementId: "G-FS0VSFH3MN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth = getAuth();
